module.exports = __webpack_public_path__ + "assets/img/e24ac6043b08245dd4b0325eb6d23ebb.svg";